<template>
  <div id="app">
    <notifications group="mensagens" class="mt-2" />
    <router-view />
    <FooterComponent :softwareVersion="softwareVersion"></FooterComponent>
  </div>
</template>

<script>
import FooterComponent from "@/components/FooterComponent";
export default {
  components: {
    FooterComponent,
  },
  data() {
    return {
      softwareVersion: null,
    }
  },
  watch: {
    $route(route) {
      if (route.meta.nomeIndicador) {
        const token = sessionStorage.getItem("token");
        let nomeIndicador = route.meta.nomeIndicador[0];

        if (
          route.meta.nomeIndicador.length === 2 &&
          route.params[route.meta.modificadorDoIndicador]
        ) {
          nomeIndicador = route.meta.nomeIndicador[1];
        }

        this.$conexaApi.put(
          `/integration/ativacao/paciente/${token}/atualizar-acesso-tela`,
          {
            telaAtivacao: nomeIndicador,
          }
        );
      }
    },
  },
  beforeMount() {
    let layout = sessionStorage.getItem("layout");
    if (layout && layout.toLowerCase() === "docpass") {
      document
        .getElementById("estilo_conexa")
        .setAttribute("disabled", "disabled");
      document.getElementById("estilo_docpass").removeAttribute("disabled");
      sessionStorage.setItem("layout", "docpass");
    }

    // eslint-disable-next-line no-console
    this.$conexaApi.get('/controle/versao/sistema/obter').then(response => {
      this.softwareVersion = response.data.object.versaoSistema || null
    });
  },
};
</script>
